<template>
    <div class="content container-fluid">
        <!-- Page Header -->
        <div class="page-header">
            <div class="row align-items-center">
                <div class="col">
                    <h3 class="page-title">Query Tool</h3>
                </div>
            </div>
        </div>
        <!-- /Page Header -->

        <!-- Form -->
        <div class="row align-items-center">
            <div class="col-md-1 fit-content pr-md-0">Database</div>
            <div class="col-md-2 fit-content">
                <select class="custom-select" v-model="db">
                    <option value="BoardRoomDB">Benefit Connect</option>
                    <option value="IgniteDB">Ignite</option>
                </select>
            </div>
        </div>
        <div class="row mt-3">
            <div class="col-md-8">
                <textarea class="form-control" v-model="sql" placeholder="Enter your SQL query here..." rows="5">
                </textarea>
            </div>
        </div>
        <div class="row mt-2">
            <div class="col-md-8 text-right">
                <button class="btn btn-primary" @click="executeQuery">Execute</button>
            </div>
        </div>
        <!-- /Form -->

        <!-- Table Result -->
        <div class="row mt-4 font-small" v-if="records != null">
            <div class="col-md-12">Total Records: {{ totalRecords }}</div>
        </div>
        <div class="row mt-1 font-small" v-if="records != null && records.length > 0">
            <div class="col-md-12">
                <div class="table-responsive">
                    <table class="table table-bordered custom-table mb-0">
                        <thead class="thead-light">
                            <tr>
                                <th v-for="header in Object.keys(records[0])" :key="header">{{ header }}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(record, i) in records" :key="i">
                                <td v-for="(value, j) in Object.values(record)" :key="i + '-' + j">{{ value }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <!-- /Table Result -->
    </div>
</template>

<script>
import API from "../../http-common.js";
export default {
    data() {
        return {
            records: null,
            totalRecords: null,
            db: "BoardRoomDB",
            sql: ""
        }
    },
    computed: {
        token() {
            let data = JSON.parse(localStorage.getItem("lambitoken"));
            return data.Token;
        },
        role() {
            let data = JSON.parse(localStorage.getItem("lambitoken"));
            return data.Role;
        },
    },
    methods: {
        executeQuery() {
            let param = {
                Db: this.db,
                Sql: this.sql
            }
            this.$store.state.isLoading = true;
            API.executeQuery(param)
                .then((response) => {
                    this.$store.state.isLoading = false;
                    if (response.data.success) {
                        let result = response.data.result;
                        this.records = result.Rows;
                        this.totalRecords = result.RowCount;
                    } else {
                        this.$swal(response.data.message, { icon: "error" });
                    }
                })
                .catch((error) => {
                    this.$store.state.isLoading = false;
                    this.$swal(error.response.data.Message, { icon: "error" });
                });
        }
    },
    created() {
        if (this.role != "admin") this.$router.replace({ name: "home" });
    }
}
</script>

<style scoped>
.fit-content {
    max-width: fit-content;
}

.font-small {
    word-spacing: -3px;
    font-size: 13px;
}
</style>


// WEBPACK FOOTER //
// src/components/System/QueryTool.vue